export default "__VITE_ASSET__256d14b3__"